import BondPrincipalAttorneySearchSection from "./BondPrincipalAttorneySearchSection";
import SelectedAttorneySummary from "./SelectedAttorneySummary";
import {
  buildBondPrincipalAttorneySearchSectionProps,
  buildStandardPrincipalAttorneyFormContext,
  handleStandardPrincipalAttorneySelection,
} from "../utils/bondGuardianAttorneyWiring";

export { buildStandardPrincipalAttorneyFormContext };

export function StandardPrincipalAttorneySearchSection({
  apiClient,
  role,
  lawfirmId,
  toast,
  updateData,
  data,
  guardians,
  guardian,
  guardianIndex,
  fieldError,
  renderAfterSummary,
  addressLabel = "Office Address",
}) {
  return (
    <BondPrincipalAttorneySearchSection
      {...buildBondPrincipalAttorneySearchSectionProps({
        apiClient,
        role,
        lawfirmId,
        toast,
        updateData,
        data,
        guardians,
        guardian,
        guardianIndex,
        selectionHandler: handleStandardPrincipalAttorneySelection,
        fieldError,
      })}
    >
      {(attorneys) => (
        <>
          <SelectedAttorneySummary
            attorneys={attorneys}
            guardian={guardian}
            addressLabel={addressLabel}
          />
          {renderAfterSummary ? renderAfterSummary({ attorneys }) : null}
        </>
      )}
    </BondPrincipalAttorneySearchSection>
  );
}

export function renderStandardPrincipalAttorneyBranch(
  formContext,
  guardian,
  guardianIndex,
  options = {}
) {
  return (
    <StandardPrincipalAttorneySearchSection
      {...formContext}
      guardian={guardian}
      guardianIndex={guardianIndex}
      renderAfterSummary={options.renderAfterSummary}
      addressLabel={options.addressLabel}
    />
  );
}

function buildStandardPrincipalAttorneySearchCall(
  form,
  guardian,
  guardianIndex,
  fieldError
) {
  return {
    formContext: buildStandardPrincipalAttorneyFormContext({
      ...form,
      fieldError,
    }),
    guardian,
    guardianIndex,
  };
}

export function renderVaPrincipalAttorneySearch(
  form,
  guardian,
  guardianIndex,
  fieldError
) {
  const { formContext, guardian: principal, guardianIndex: index } =
    buildStandardPrincipalAttorneySearchCall(form, guardian, guardianIndex, fieldError);
  return renderStandardPrincipalAttorneyBranch(formContext, principal, index);
}

export function renderTrusteePrincipalAttorneySearch(
  form,
  guardian,
  guardianIndex,
  fieldError,
  renderAfterSummary
) {
  const { formContext, guardian: principal, guardianIndex: index } =
    buildStandardPrincipalAttorneySearchCall(form, guardian, guardianIndex, fieldError);
  return renderStandardPrincipalAttorneyBranch(formContext, principal, index, {
    renderAfterSummary,
  });
}

export default StandardPrincipalAttorneySearchSection;
